import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import Carousel from "../../../Carousel/Carousel";
import { GatsbyImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";


const ImageModal = (data) => {

    const bigImages = data.images
    const images = data.thumbs
    // const [nav1, setNav1] = useState();
    // const [nav2, setNav2] = useState();
    const [slideCount, setSlideCount] = useState(1);
    const slider = useRef(null);

    const settings = {
        arrows: true,
        lazyLoad: 'false',
        afterChange: current => setSlideCount(current + 1),
        initialSlide: 5
    }
    slider.current?.slickGoTo(data.slideIndex);
    useEffect(()=>{
        setSlideCount(data.slideIndex + 1);
    }, [data.slideIndex])

    return(
        <div className="w-full top-0 absolute lg:px-24 lg:pt-24 md:pt-24 text-right">
            <span className="text-gray cursor-pointer w-3/6 mx-auto text-right text-2xl lg:mr-24 lg:relative absolute lg:top-8 md:top-40 top-48 right-8 z-50" ><FontAwesomeIcon icon={faTimesCircle} onClick={data.click} /></span>
            <Slider ref={slider} slidesToShow={1} slidesToScroll={1} infinite={false} {...settings} style={{maxHeight: '750px'}} >
                {bigImages}
            </Slider>
            <div className="w-11/12 mx-auto text-left">
                <span>{slideCount} / {bigImages.length} </span>
            </div>
            
            {/* <Slider asNavFor={nav1} ref={(slider2) => setNav2(slider2)} slidesToShow={5} slidesToScroll={1} infinite={false} focusOnSelect={true} centerMode={true} arrows={false} style={{maxHeight: '150px'}}>
                {images}
            </Slider> */}
        </div>
    )
}

export default ImageModal